import React from "react";
import EtimSelection from "./EtimSelection";
import EtimCharacteristics from "./EtimCharacteristics";
import EtimSummary from "./EtimSummary";

export default function EtimModalWizard(props) {
  const { progress } = props;

  function renderProgress() {
    switch (progress) {
      case "select":
        return <EtimSelection {...props} />;
      case "characteristics":
        return <EtimCharacteristics {...props} />;
      case "finish":
        return <EtimSummary {...props} />;
      default:
        return null;
    }
  }

  return <div>{renderProgress(progress)}</div>;
}
